import { commonAttributes, tableColumnDefaultOption } from 'app/config'
import { validateNotEmpty } from 'app/validators'

import { PRESCHOOL_LEVEL_OPTIONS } from '../constants'

export const columns = [
  { ...commonAttributes.uuid },
  {
    name: 'skill_name',
    label: 'Skill',
    disabledInForm: true,
    ...tableColumnDefaultOption
  },
  {
    name: 'skill',
    label: 'Skill UUID',
    // Backend requires skill (non-null FK). Validate client-side so a missing
    // value surfaces as a clear form error instead of a raw 400 on save.
    validate: validateNotEmpty,
    options: { ...tableColumnDefaultOption.options, display: 'false' }
  },
  {
    name: 'level',
    label: 'Level',
    widget: 'select',
    widgetFilter: true,
    validate: validateNotEmpty,
    valueLabelMappings: PRESCHOOL_LEVEL_OPTIONS,
    ...tableColumnDefaultOption
  },
  {
    name: 'month',
    label: 'Month',
    validate: validateNotEmpty,
    ...tableColumnDefaultOption
  },
  {
    name: 'annual_lo_name',
    label: 'Annual LO',
    disabledInForm: true,
    ...tableColumnDefaultOption
  },
  {
    name: 'annual_lo',
    label: 'Annual LO UUID',
    optional: true,
    ...tableColumnDefaultOption
  },
  {
    name: 'annual_lo_inferred',
    label: 'Inferred',
    widget: 'checkbox',
    optional: true,
    ...tableColumnDefaultOption
  },
  {
    name: 'is_culmination',
    label: 'Culmination',
    widget: 'checkbox',
    optional: true,
    ...tableColumnDefaultOption
  },
  {
    name: 'name',
    label: 'Name',
    validate: validateNotEmpty,
    ...tableColumnDefaultOption
  },
  {
    name: 'text',
    label: 'Text',
    widget: 'textarea',
    optional: true,
    ...tableColumnDefaultOption
  },
  {
    name: 'order_in_month',
    label: 'Order in month',
    optional: true,
    ...tableColumnDefaultOption
  },
  {
    name: 'is_active',
    label: 'Active',
    widget: 'checkbox',
    // Active by default on create (mirrors the request builder's
    // `is_active !== false` default). Only applied on the create path; edit
    // uses the record's real boolean value.
    defaultValue: () => true,
    ...tableColumnDefaultOption
  }
]
